<template>
  <v-layout row justify-center id="cp">
    <v-dialog v-model="visible" content-class="add-call-dialog" width="325px" v-click-outside="close">
      <v-card content-class="add-call-dialog">
        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ title }}</span>
        </v-card-title>
        <search :searchFilter.sync="searchFilter"  />
        <v-list class="call--scroll-list">
          <v-list-tile
            v-for="item in filteredItems"
            :key="item.title"
            @click="itemClicked(item)"
            :class="selected(item)"
            style="height: 45px !important;"
          >
            <v-list-tile-avatar>
              <user-avatar 
                :avatar="item.avatar"
                :username="item.name" 
                :size="38"
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-text="item.name" ></v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            flat
            @click="close"
          >
            {{ this.$t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="nextDisabled"
            color="primary"
            depressed
            @click="next"
          >
            {{ this.$t('next_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  #cp .add-call-dialog {
    height: 600px;
    table-layout: fixed;
  }
  #cp .call--scroll-list {
    height: 458px;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>

<script> 
  import UserAvatar from '@common/UserAvatar.vue'
  import Search from '@common/Search.vue'

  export default {
    name: 'contact-picker',
    data: () => ({
      items: [],
      selectedItems: [],
      searchFilter:'',
      filteredItems: [],
      excludeItems: [],
      callback: () => {
        console.warn('[ContactPicker] use setCallback to get result')
      }
    }),
    components: { UserAvatar, Search },
    computed: {
      nextDisabled() { return !this.selectedItems.length }
    },
    props: {
      title: String,
      multiselect: {
        type: Boolean, 
        default: true
      },
      visible: {
        type: Boolean, 
        default: false
      }
    },
    methods: {
      fetchContacts() {
        this.items = this.$store.state.contacts
        if (this.excludeItems.length > 0)
          this.items = this.items.filter(item => !this.excludeItems.includes(item.contactId))
        this.filteredItems = this.items
      },
      close() {
        if (!this.visible)
          return
        // reset all variables
        this.selectedItems = []
        this.searchFilter = ''
        this.$emit('update:visible', false)
      },
      next() {
        const users = this.selectedContacts()
        this.callback(users)
        this.close()
      },
      selected(item) {
        return (this.selectedItems.includes(item)) ? 'accent' : ''
      },
      selectedContacts() {
        let users = []
        this.selectedItems.forEach((item) => users.push(item.contactId))
        return users
      },
      itemClicked(item){
        if (this.multiselect) {
          if (this.selectedItems.includes(item)) {
            this.selectedItems.splice(this.selectedItems.indexOf(item), 1)
          } else {
            this.selectedItems.push(item)
          }
        } else {
          this.selectedItems = [item]
        }
      },
      exclude(items) {
        this.excludeItems = items
      },
      setCallback(cb) {
        this.callback = cb
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue)
          this.fetchContacts()
      },
      searchFilter: function(newValue, oldValue) {
        if (newValue && this.searchFilter !== '') {
          const filter = new RegExp(this.searchFilter, 'i')
          this.filteredItems = this.items.filter(it => it.name.match(filter))
        } else {
          this.filteredItems = this.items
        }
      }
    }
  }
</script>